import styled from '@emotion/styled';
import {
  Button,
  Divider,
  Drawer,
  Input,
  message,
  Modal,
  Progress,
  Select,
  Space,
  Typography,
  Upload,
} from 'antd';

import axios from 'axios';
import { useEffect, useState } from 'react';

import { MdClose } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { ConnectedUserEntity } from '../../../entities/ConnectedUserEntity';
import { DetenteurEntity } from '../../../entities/detenteur.entity';
import { Layout } from '../../../modules/shared/Layout';
import { ORANGE, PRIMARY, YELLOW } from '../../../shared/colors';
import { formatNum } from '../../../shared/constants';
import {
  addAML,
  addKYC,
  getUserAML,
  getUserKYC,
  getUserPortefeuille,
  getUserPortefeuilleKPI,
  updateAML,
  updateKYC,
} from '../../dashboard/components/Monitor/network';
import { BASE_MEDIA } from '../../shared/ApiRoutes';
import Loading from '../../shared/Loading';

const { Title, Text } = Typography;

const Container = styled.div`
  font-family: Poppins-R;
  zoom: 0.95;
  height: 100%;

  table,
  th,
  td {
    // font-weight: bold;
    border-bottom: 2px solid #666;
    border-top: 2px solid #666;
    padding-left: 5px;
  }

  td {
    margin: 2px;
  }

  td div {
    padding: 5px.;
  }

  .anticon {
    color: white;
  }

  .colortrans td {
    // background-color: rgba(255, 255, 255, 0.5);
  }

  td
    .ant-select-single.ant-select-sm:not(.ant-select-customize-input)
    .ant-select-selector {
    padding: 0 7px;
    background-color: transparent;
    color: white;
    border: none;
  }

  td .coloriage {
    background-color: ${YELLOW};
    color: #fff;
    width: 100%;
    padding-left: 2px;
  }

  td .coloriage2 {
    padding-left: 2px;
    background-color: #ccc;
    color: #111;
    width: 100%;
  }

  td .coloriage1 {
    background-color: ${ORANGE};
    color: #fff;
    width: 100%;
  }

  .qteInput {
    width: 100px;
    height: 25px;
    background-color: transparent;
    color: #fff;
    border: none;
  }

  > .top {
    background-color: ${PRIMARY};
    padding: 5px;
    font-family: Poppins-R;
    border-radius: 5px;
    text-transform: uppercase;
    display: flex;
    justify-content: space-between;
  }

  > .content {
    padding: 0px 25px 0px 25px;
    display: flex;
    flex-direction: column;
    height: 80%;
    zoom: 0.85;

    > div {
      flex: 1;
    }
  }

  .button {
    padding: 10px 15px 10px 15px;
    border-radius: 5px;
    margin-botton: 10px;
    background-color: ${ORANGE};
    color: white;
  }

  Input,
  Textarea,
  .ant-upload,
  Upload {
    margin-bottom: 10px;
    margin-top: 10px;
  }

  Drawer Input {
    margin-bottom: 10px;
  }

  .ant-upload-list {
    color: white;
    margin-bottom: 5px;
  }
  .main {
    display: flex;
    width: 100%;
    font-size: 17px;
    padding: 10px;
    gap: 10px;
    height: calc(100vh - 60px);
  }
  .left,
  .right {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .photo {
    width: 100px;
    margin-bottom: 10px;
    cursor: zoom-in;
    transition: transform 0.2s;
  }

  .photo:hover {
    transform: scale(1.05);
  }

  .left {
    flex: 1;
  }

  .right {
    flex: 1;
  }

  .box {
    background-color: #1c2025;
    border-radius: 5px;
    flex: 1;
    border: 1px solid grey;
  }

  card {
      padding: 20,
      border: '1px solid #e8e8e8',
      borderRadius: 10,
      boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
      color: 'white',
    }

    .ant-typography {
      color: 'white',
    }
`;

export const ProfilKycPage = () => {
  const [formData, setFormData] = useState({
    full_name: '',
    birth_date: '',
    nationality: '',
    id_type: '',
    id_number: '',
    address: '',
    employment_status: '',
    income_level: '',
    investment_purpose: '',
    politically_exposed: 'non',
    country_of_residence: '',
  });

  const styles = {
    card: {
      padding: 20,
      border: '1px solid #e8e8e8',
      borderRadius: 10,
      boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
      color: 'white',
    },

    Text,
    Title: {
      color: 'white',
    },
  };

  const [files, setFiles] = useState<{ [key: string]: File }>({});
  const [loading, setLoading] = useState(false);
  const [detenteursPF, setDetenteursPF] = useState<DetenteurEntity[]>([]);
  const [showDrawer, setShowDrawer] = useState(false);
  const [kyc, setKYC] = useState<any>({});
  const [aml, setAML] = useState<any>({});
  const [portefeuilleKPI, setPortefeuilleKPI] = useState<any>();
  const [completion, setCompletion] = useState(0);
  const [previewImage, setpreviewImage] = useState('');
  const [isModalVisible, setIsModalVisible] = useState(false);
  const connectedUser: ConnectedUserEntity = useSelector(
    (state: any) => state.userReducer,
  ).user;

  const currentStep = 2; // Exemple : étape 3 en cours (0-indexed)

  // const steps = [
  //   { label: 'Informations personnelles', status: 'done' },
  //   { label: 'Pièce d’identité reçue', status: 'done', date: '09/07/2025' },
  //   {
  //     label: 'Justificatif de domicile',
  //     status: 'pending',
  //   },
  //   { label: 'Vérification manuelle', status: 'todo' },
  //   { label: 'Compte activé', status: 'todo', isLock: true },
  // ];

  useEffect(() => {
    fetchData();
  }, []);

  const handleInput = (e) => {
    const { name, value } = e.target;
    const updated = { ...formData, [name]: value };
    setFormData(updated);
    updateProgress(updated, files);
  };

  const handleFile = (name, file) => {
    const updated = { ...files, [name]: file };
    setFiles(updated);
    updateProgress(formData, updated);
  };

  const fetchData = async () => {
    setLoading(true);

    await getUserKYC(connectedUser.id).then(async ({ data }) => {
      setKYC(data);
      if (data.error) {
        if (data.error === 'KYC introuvable') {
        }
      } else {
        setKYC(data);
        // Préremplir les valeurs texte
        setFormData({
          full_name: data.full_name || '',
          birth_date: data.birth_date ? data.birth_date.slice(0, 10) : '',
          nationality: data.nationality || '',
          id_type: data.id_type || '',
          id_number: data.id_number || '',
          address: data.address || '',
          employment_status: data.employment_status || '',
          income_level: data.income_level || '',
          investment_purpose: data.investment_purpose || '',
          politically_exposed:
            typeof data.politically_exposed === 'boolean'
              ? data.politically_exposed
              : false,
          country_of_residence: data.country_of_residence || '',
        });

        await preloadFilesFromKYC(data, setFiles);
        updateProgress(data, {});
      }
    });

    await getUserAML(connectedUser.id).then(async ({ data }) => {
      setAML(data);
      if (data.error) {
        if (data.error === 'AML introuvable') {
        }
      } else {
        setAML(data);
      }
    });

    await getUserPortefeuille(connectedUser.id).then(({ data }) => {
      setDetenteursPF(data);
    });

    await getUserPortefeuilleKPI(connectedUser.id).then(({ data }) => {
      setPortefeuilleKPI(data);
    });
    setLoading(false);
  };

  const preloadFilesFromKYC = async (kycData, setFiles) => {
    const fileKeys = [
      'id_document_front',
      'id_document_back',
      'selfie',
      'proof_of_residency',
    ];

    for (const key of fileKeys) {
      const fileUrl = kycData[key];
      if (fileUrl) {
        try {
          const response = await fetch(BASE_MEDIA + fileUrl);
          const blob = await response.blob();

          const fileExtension = fileUrl.split('.').pop();
          const filename = `${key}.${fileExtension}`;

          const file = new File([blob], filename, { type: blob.type });

          setFiles((prev) => ({
            ...prev,
            [key]: file,
          }));
        } catch (error) {
          console.error(`Erreur lors du chargement du fichier ${key}`, error);
        }
      }
    }
  };

  const updateProgress = (data, fileData) => {
    const totalFields = 14;
    let filled = 0;
    Object.values(data).forEach((val) => {
      if (val && val !== '') filled++;
    });
    Object.values(fileData).forEach((val) => {
      if (val) filled++;
    });
    const percent = Math.min(Math.round((filled / totalFields) * 100), 100);
    setCompletion(percent);
  };

  const handleSubmit = async () => {
    setLoading(true);
    const data = new FormData();

    // Ajoute les champs texte
    Object.entries(formData).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        data.append(key, value);
      }
    });

    // Ajoute seulement les fichiers nouvellement sélectionnés
    Object.entries(files).forEach(([key, value]) => {
      if (value) {
        data.append(key, value);
      }
    });

    data.append('user', connectedUser.id);

    try {
      if (kyc && kyc.id) {
        await updateKYC(kyc.id, data);
        message.success('Informations KYC mises à jour');
      } else {
        await addKYC(data);
        // ajouter le AML
        const data1 = new FormData();
        data1.append('income_level', formData.income_level);
        data1.append('country_of_residence', formData.country_of_residence);
        data1.append('is_pep', formData.politically_exposed);
        data1.append('user', connectedUser.id);
        await addAML(data1);
        message.success('KYC soumis avec succès');
      }

      // ajouter le AML
      if (aml && aml.id) {
        const data1 = new FormData();
        data1.append('income_level', formData.income_level);
        data1.append('country_of_residence', formData.country_of_residence);
        data1.append('is_pep', formData.politically_exposed);
        data1.append('user', connectedUser.id);
        await updateAML(aml.id, data1);
      } else {
        const data1 = new FormData();
        data1.append('income_level', formData.income_level);
        data1.append('country_of_residence', formData.country_of_residence);
        data1.append('is_pep', formData.politically_exposed);
        data1.append('user', connectedUser.id);
        await addAML(data1);
      }

      await fetchData(); // Recharge les données
    } catch (error) {
      message.error('Erreur lors de la soumission');
    }

    setLoading(false);
  };

  const handleDownloadPDF = async () => {
    try {
      const res = await axios.get('/api/kyc/pdf/', { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Mon_Dossier_KYC.pdf');
      document.body.appendChild(link);
      link.click();
    } catch (err) {
      message.error('Impossible de télécharger le dossier PDF.');
    }
  };

  const showModal = (val) => {
    setIsModalVisible(true);
    setpreviewImage(val);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return loading ? (
    <Loading />
  ) : (
    <Layout>
      <Container>
        <div className='main'>
          <div className='left'>
            <div className='container box'>
              <Container>
                <div className='top' style={{ padding: 10, marginBottom: 5 }}>
                  <Space>
                    <div style={{ color: 'orange' }}>Profil Utilisateur</div>
                  </Space>
                </div>

                <div className='content'>
                  <div style={{ margin: 5 }}>
                    {connectedUser ? (
                      <div className='space-y-2'>
                        <p>
                          <strong>Nom :</strong>{' '}
                          {connectedUser.prenom + ' ' + connectedUser.nom}
                        </p>
                        <p>
                          <strong>Email :</strong>
                          {connectedUser.email}
                        </p>
                        <p>
                          <strong>Agence :</strong>
                          {connectedUser.agence.nom}
                        </p>
                        <p>
                          <strong>Gestionnaire :</strong>
                          {connectedUser.partenaire.nom}
                        </p>
                        <p>
                          <strong>Profil :</strong>
                          <ul>
                            {connectedUser.profils.map((profil) => (
                              <li>{profil.nom}</li>
                            ))}
                          </ul>
                        </p>
                      </div>
                    ) : (
                      <p>Chargement du profil...</p>
                    )}
                    <Divider
                      style={{ backgroundColor: 'orange', marginBottom: 5 }}
                    />
                    <h2 style={{ color: 'orange', marginBottom: 5 }}>
                      Portefeuille estimé
                    </h2>
                    <p>
                      <strong>Total estimé :</strong>
                      {portefeuilleKPI
                        ? formatNum(portefeuilleKPI?.valeurPortefeuille)
                        : '--'}{' '}
                      XAF
                    </p>
                    <p>
                      <strong>Rendement :</strong>
                      {portefeuilleKPI
                        ? Math.round(
                            (portefeuilleKPI?.rendement * (1 + 0.001 / 100) +
                              Number.EPSILON) *
                              100,
                          ) / 100
                        : '--'}{' '}
                      %
                    </p>
                    <p>
                      <strong>PNL :</strong>{' '}
                      {portefeuilleKPI ? formatNum(portefeuilleKPI?.pnl) : '--'}{' '}
                      XAF
                    </p>
                    <p>
                      <Button
                        onClick={() => {
                          setShowDrawer(true);
                        }}
                        loading={loading}
                        className='w-full md:w-auto'
                      >
                        Depot Orange Money
                      </Button>
                    </p>
                    <Divider
                      style={{ backgroundColor: 'orange', marginBottom: 5 }}
                    />
                    <h2 style={{ color: 'orange', marginBottom: 5 }}>
                      Status KYC
                    </h2>
                    {/* <div style={styles.card}>
                      <Title level={4}>
                        <LockOutlined /> Votre compte est en cours de
                        vérification
                      </Title>
                      <Text>
                        Vous pouvez consulter ci-dessous les étapes de votre
                        vérification KYC/AML.
                      </Text>

                      <Timeline style={{ marginTop: 20 }}>
                        {steps.map((step, index) => (
                          <Timeline.Item
                            key={index}
                            color={
                              step.status === 'done'
                                ? 'green'
                                : step.status === 'pending'
                                ? 'orange'
                                : 'gray'
                            }
                            dot={
                              step.status === 'done' ? (
                                <CheckCircleFilled style={{ color: 'green' }} />
                              ) : step.warning ? (
                                <ExclamationCircleOutlined
                                  style={{ color: 'orange' }}
                                />
                              ) : step.isLock ? (
                                <LockOutlined />
                              ) : undefined
                            }
                          >
                            <Text strong>{step.label}</Text>
                            {step.date && (
                              <div>
                                <Text>{step.date}</Text>
                              </div>
                            )}
                            {step.warning && (
                              <div>
                                <Text>⚠ {step.warning}</Text>
                              </div>
                            )}
                          </Timeline.Item>
                        ))}
                      </Timeline>

                      <Button type='primary' style={{ marginTop: 20 }}>
                        Accéder à mes documents
                      </Button>
                      <div style={{ marginTop: 10 }}>
                        <Text type='secondary'>
                          Pourquoi cette vérification ?{' '}
                          <a href='#'>Lire notre politique</a>
                        </Text>
                      </div>
                    </div> */}
                  </div>
                </div>
              </Container>
            </div>
          </div>
          <div className='right box'>
            <div className='container box'>
              <Container>
                <div className='top' style={{ padding: 10, marginBottom: 5 }}>
                  <Space>
                    <div style={{ color: 'orange' }}>
                      Soumettre vos informations KYC & AML
                    </div>
                  </Space>
                  {/* <Button
                    style={{ color: 'white', background: 'orange' }}
                    onClick={handleDownloadPDF}
                  >
                    Télécharger PDF
                  </Button> */}
                </div>

                <div className='content'>
                  <div style={{ margin: 5 }}>
                    <div className='flex items-center justify-between'>
                      <div className='flex items-center gap-4'>
                        <Progress
                          percent={completion}
                          size='small'
                          status={completion === 100 ? 'success' : 'active'}
                        />
                      </div>
                    </div>

                    <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                      <Input
                        type='date'
                        name='birth_date'
                        placeholder='Date de naissance'
                        value={formData.birth_date}
                        onChange={handleInput}
                      />
                      <Input
                        name='nationality'
                        placeholder='Nationalité'
                        value={formData.nationality}
                        onChange={handleInput}
                      />
                      <Input
                        name='country_of_residence'
                        placeholder='Pays de résidence'
                        value={formData.country_of_residence}
                        onChange={handleInput}
                      />
                      <Input
                        name='id_type'
                        placeholder='Type de pièce (ex: CNI, Passeport)'
                        value={formData.id_type}
                        onChange={handleInput}
                      />
                      <Input
                        name='id_number'
                        placeholder='Numéro de pièce'
                        value={formData.id_number}
                        onChange={handleInput}
                      />
                    </div>

                    <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                      <Upload
                        accept='image/*' // 🔒 accepte uniquement les images côté navigateur
                        beforeUpload={(file) => {
                          const isImage = file.type.startsWith('image/');
                          if (!isImage) {
                            message.error('Seules les images sont autorisées');
                            return Upload.LIST_IGNORE; // 🚫 ignore le fichier
                          }

                          handleFile('id_document_front', file);
                          return false; // empêche l'upload automatique
                        }}
                        showUploadList={false}
                      >
                        <Button>Document - Recto</Button>
                      </Upload>

                      {kyc.id_document_front && (
                        <div>
                          <img
                            src={BASE_MEDIA + kyc.id_document_front}
                            className='photo'
                            alt='Document Recto'
                            onClick={() =>
                              showModal(BASE_MEDIA + kyc.id_document_front)
                            }
                            style={{ maxWidth: '300px', marginTop: '10px' }}
                          />
                        </div>
                      )}

                      <Upload
                        accept='image/*' // 🔒 accepte uniquement les images côté navigateur
                        beforeUpload={(file) => {
                          const isImage = file.type.startsWith('image/');
                          if (!isImage) {
                            message.error('Seules les images sont autorisées');
                            return Upload.LIST_IGNORE; // 🚫 ignore le fichier
                          }

                          handleFile('id_document_back', file);
                          return false; // empêche l'upload automatique
                        }}
                        showUploadList={false}
                      >
                        <Button>Document - Verso</Button>
                      </Upload>

                      {kyc.id_document_back && (
                        <div>
                          <img
                            src={BASE_MEDIA + kyc.id_document_back}
                            alt='Document Recto'
                            className='photo'
                            onClick={() =>
                              showModal(BASE_MEDIA + kyc.id_document_back)
                            }
                            style={{ maxWidth: '300px', marginTop: '10px' }}
                          />
                        </div>
                      )}

                      <Upload
                        accept='image/*' // 🔒 accepte uniquement les images côté navigateur
                        beforeUpload={(file) => {
                          const isImage = file.type.startsWith('image/');
                          if (!isImage) {
                            message.error('Seules les images sont autorisées');
                            return Upload.LIST_IGNORE; // 🚫 ignore le fichier
                          }

                          handleFile('selfie', file);
                          return false; // empêche l'upload automatique
                        }}
                        showUploadList={false}
                      >
                        <Button>Selfie</Button>
                      </Upload>
                      {kyc.selfie && (
                        <div>
                          <img
                            src={BASE_MEDIA + kyc.selfie}
                            alt='Document Verso'
                            className='photo'
                            onClick={() => showModal(BASE_MEDIA + kyc.selfie)}
                            style={{ maxWidth: '300px', marginTop: '10px' }}
                          />
                        </div>
                      )}
                      <Upload
                        beforeUpload={(file) => (
                          handleFile('proof_of_residency', file), false
                        )}
                      >
                        <Button>Justificatif de domicile</Button>
                      </Upload>
                      {kyc.proof_of_residency && (
                        <a
                          href={BASE_MEDIA + kyc.proof_of_residency}
                          target='_blank'
                          className='button'
                          rel='noopener noreferrer'
                        >
                          Voir
                        </a>
                      )}
                      <br />
                      <Upload
                        beforeUpload={(file) => (
                          handleFile('proof_of_revenue', file), false
                        )}
                      >
                        <Button>Justificatif de revenue</Button>
                      </Upload>
                      {kyc.proof_of_revenue && (
                        <a
                          href={BASE_MEDIA + kyc.proof_of_revenue}
                          target='_blank'
                          className='button'
                          rel='noopener noreferrer'
                        >
                          Voir
                        </a>
                      )}
                      <br />
                    </div>

                    <Input.TextArea
                      name='address'
                      placeholder='Adresse complète'
                      value={formData.address}
                      onChange={handleInput}
                      rows={2}
                    />

                    <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                      <Input
                        name='employment_status'
                        placeholder='Profession'
                        value={formData.employment_status}
                        onChange={handleInput}
                      />
                      <Input
                        name='investment_purpose'
                        placeholder="Objectif d'investissement"
                        value={formData.investment_purpose}
                        onChange={handleInput}
                      />
                      <br />
                      <label>Personne Politiquement Expose?: </label>
                      <Select
                        value={formData.politically_exposed}
                        onChange={(value) =>
                          setFormData((prev) => ({
                            ...prev,
                            politically_exposed: value,
                          }))
                        }
                        options={[
                          { label: 'Oui', value: true },
                          { label: 'Non', value: false },
                        ]}
                      />
                      <br />
                      <label>Revenue: </label>
                      <Select
                        value={formData.income_level}
                        onChange={(value) =>
                          setFormData((prev) => ({
                            ...prev,
                            income_level: value,
                          }))
                        }
                        options={[
                          { value: 'Non déclaré', label: 'Non déclaré' },
                          {
                            value: 'Faible',
                            label: 'Faible (< 100 000 XAF/mois)',
                          },
                          {
                            value: 'Moyen',
                            label: 'Moyen (100 000 à 500 000 XAF/mois)',
                          },
                          {
                            value: 'Élevé',
                            label: 'Élevé (> 500 000 XAF/mois)',
                          },
                          {
                            value: 'Très élevé',
                            label: 'Très élevé (> 1 000 000 XAF/mois)',
                          },
                        ]}
                      />
                    </div>

                    <div className='pt-6'>
                      <Button
                        onClick={handleSubmit}
                        loading={loading}
                        className='w-full md:w-auto'
                      >
                        {kyc && kyc.id ? 'Mettre à jour' : 'Soumettre'}
                      </Button>
                    </div>
                  </div>
                </div>
              </Container>
            </div>
          </div>
        </div>
        <Drawer
          title='Recharger votre compte via Orange Money'
          placement='right'
          width={400}
          onClose={() => setShowDrawer(false)}
          open={showDrawer}
          closeIcon={<MdClose size={20} />}
        >
          <div style={{ margin: 5 }}>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
              <Input
                style={{ margin: 5 }}
                name='number_tel'
                placeholder='Numero de telephone'
                value=''
                onChange={handleInput}
              />
              <Input
                style={{ margin: 5 }}
                name='montant'
                placeholder='Montant'
                value=''
                onChange={handleInput}
              />
            </div>

            <div className='pt-6'>
              <Button
                loading={loading}
                style={{ margin: 5, background: 'orange' }}
                className='w-full md:w-auto'
                onClick={() => setLoading(true)}
              >
                Payer
              </Button>
            </div>
          </div>
        </Drawer>
      </Container>
      <Modal
        open={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        centered
      >
        <img
          src={previewImage}
          alt='Aperçu agrandi'
          style={{ width: '100%' }}
        />
      </Modal>
    </Layout>
  );
};
